import { Controller } from 'stimulus';

class DynamicsController extends Controller {
  connect() {
    this.origins = this.data.get('origins').split(',');

    setTimeout(() => {
      if (this.element) {
        this.element.style.opacity = 1;
      }
    }, 2500);

    // Some browsers do not handle postMessage and message handling. Maybe
    // because of privacy concerns. To make the form visible either way, we
    // fallback on just showing the form with a fixed height.
    let hasHandledMessage = false;

    // The <iframe> has a postMessage call with the dimensions of the iframe.
    // this listener catches it and updates the iframe element.
    window.addEventListener('message', (event) => {
      hasHandledMessage = true;
      this.onWindowMessage(event);
    });

    // Fallback for browsers that do not support postMessage.
    setTimeout(() => {
      if (!hasHandledMessage) {
        this.element.style.height = '1000px';
        this.element.style.opacity = 1;
      }
    }, 5000);
  }

  onWindowMessage(event) {
    // eslint-disable-next-line eqeqeq
    if (this.data.get('blockId') != event.data.blockId) {
      return;
    }

    // Make sure the event is originating from an authorized origin
    if (this.origins.indexOf(event.origin) < 0) {
      // eslint-disable-next-line no-console
      console.error(`Dynamics callback blocked, ${event.origin} is not allowed.`);
      return;
    }

    this.element.style.height = `${event.data.height}px`;
    this.element.style.opacity = 1;
  }
}

export default DynamicsController;
